import React from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import HeroText from '../../Components/HeroText/HeroText';
import BlogList from '../../Components/BlogList/BlogList';
import { CONSTANT, SEO } from '../../Utils/Constant';

const Blog = () => {
  return (
    <>
      <Helmet>
        <title>{SEO.BLOG_PAGE_TITLE}</title>
        <meta name="robots" content="index, follow" />
        <meta name="description" content={SEO.BLOG_PAGE_DESCRIPTION} />
        <meta name="keywords" content={SEO.BLOG_PAGE_KEYWORDS} />
        <link rel="canonical" href={window.location.href} />
        <meta property="og:title" content={SEO.BLOG_PAGE_TITLE} />
        <meta property="og:description" content={SEO.BLOG_PAGE_DESCRIPTION} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={CONSTANT.PIXERFECT_WEB_LINK} />
        <meta property="og:site_name" content={CONSTANT.PIXERFECT_SOLUTIONS_LLP} />
        <meta property="og:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta property="twitter:image" content="https://www.pixerfect.com/Group_192_192.png" />
        <meta name="twitter:title" content={SEO.BLOG_PAGE_TITLE} />
        <meta name="twitter:description" content={SEO.BLOG_PAGE_DESCRIPTION} />
        <meta name="twitter:card" content="summary_large_image" />
      </Helmet>
      <Header />
      <HeroText
        title={'What’s Next'}
        content={
          'Explore insightful articles, expert opinions, and industry trends in our dynamic blog section. Stay informed, inspired, and ahead of the curve with our carefully curated content.'
        }
      />
      <BlogList />
      <Footer />
    </>
  );
};

export default Blog;
